import React from 'react'
import { DesignProvider } from 'contexts/DesignContext'
import Widget from './Widget'

const Index = (props) => {
  return (
    <React.Fragment>
      <DesignProvider>
        <Widget {...props} />
      </DesignProvider>
    </React.Fragment>
  )
}

export default Index
